import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import smeltingEquipment from '@/views/smeltingEquipment'
import metallurgy from '@/views/metallurgy'
import materialDev from '@/views/materialDev'
import about from '@/views/about'
import news from '@/views/news'
import contact from '@/views/contact'
import joinUs from '@/views/joinUs'

import indexEn from '@/views/indexEn'
import smeltingEquipmentEn from '@/views/smeltingEquipmentEn'
import metallurgyEn from '@/views/metallurgyEn'
import materialDevEn from '@/views/materialDevEn'
import aboutEn from '@/views/aboutEn'
// import newsEn from '@/views/newsEn'
import contactEn from '@/views/contactEn'
import joinUsEn from '@/views/joinUsEn'

Vue.use(Router)


//去掉重复路由刷新提示
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta:{title: '专业悬浮熔炼设备，悬浮冶金',keepAlive:false}
    },
    {
      path: '/smeltingEquipment',
      name: 'smeltingEquipment',
      component: smeltingEquipment,
      meta:{title: '熔炼设备',keepAlive:false}
    },
    {
      path: '/metallurgy',
      name: 'metallurgy',
      component: metallurgy,
      meta:{title: '悬浮冶金',keepAlive:false}
    },
    {
      path: '/materialDev',
      name: 'materialDev',
      component: materialDev,
      meta:{title: '材料研制',keepAlive:false}
    },
    
    {
      path: '/about',
      name: 'about',
      component: about,
      meta:{title: '关于我们',keepAlive:false}
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact,
      meta:{title: '联系我们',keepAlive:false}
    },
    {
      path: '/news',
      name: 'news',
      component: news,
      meta:{title: '新闻资讯',keepAlive:false}
    },
    {
      path: '/joinUs',
      name: 'joinUs',
      component: joinUs,
      meta:{title: '加入我们',keepAlive:false}
    },
    // 英文
    {
      path: '/en',
      name: 'indexEn',
      component: indexEn,
      meta:{title: 'Professional levitation melting equipment,levitation metallurgy',keepAlive:false}
    },
    {
      path: '/smeltingEquipment/en',
      name: 'smeltingEquipmentEn',
      component: smeltingEquipmentEn,
      meta:{title: 'MELTING EQUIPMENT',keepAlive:false}
    },
    {
      path: '/metallurgy/en',
      name: 'metallurgyEn',
      component: metallurgyEn,
      meta:{title: 'LEVITATION MELTING',keepAlive:false}
    },
    {
      path: '/materialDev/en',
      name: 'materialDevEn',
      component: materialDevEn,
      meta:{title: 'NEW MATERIALS',keepAlive:false}
    },
    
    {
      path: '/about/en',
      name: 'aboutEn',
      component: aboutEn,
      meta:{title: 'ABOUT US',keepAlive:false}
    },
    // {
    //   path: '/news/en',
    //   name: 'newsEn',
    //   component: newsEn,
    //   meta:{title: 'NEWS INFORMATION',keepAlive:false}
    // },
    {
      path: '/contact/en',
      name: 'contactEn',
      component: contactEn,
      meta:{title: 'CONTACT US',keepAlive:false}
    },
    {
      path: '/joinUs/en',
      name: 'joinUsEn',
      component: joinUsEn,
      meta:{title: 'JOIN US',keepAlive:false}
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js